export enum getSmLogHistory {
  FETCH_LOG_HISTORY = 'FETCH_LOG_HISTORY'
}
